import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLegacyComponent } from './components/button-legacy/button-legacy.component';
import { IconModule } from '../icon/icon.module';
@NgModule({
  declarations: [ButtonLegacyComponent],
  imports: [CommonModule, IconModule],
  exports: [ButtonLegacyComponent],
})
export class ButtonLegacyModule {}
